import React, { Fragment } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { Icon } from "@cdk-uip/react-icon";

import useValidation from "../../util/useValidation";
import {
  alphaNumericWithSpecialCharacterPattern,
  QUALIFICATION_TYPES,
  yearPattern
} from "../../constants/constants";
export const GraduationForm = ({
  qualificationTypeID,
  graduationDetails,
  handleOnChangeQualificationDetails,
  deleteCandidateQualificationDetails
}) => {
  const currentGraduationDetails = graduationDetails[0] || {};
  const { handleOnBlurValidation, errors } = useValidation();

  const handleOnChangeGraduationDetails = e => {
    handleOnChangeQualificationDetails(
      e,
      qualificationTypeID,
      currentGraduationDetails
    );
  };

  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  return (
    <Fragment>
      <Row>
        <Col sm={11}>
          <h6>
            {" "}
            {qualificationTypeID === QUALIFICATION_TYPES.POSTGRADUATION
              ? "Post Graduation Details"
              : "Graduation Details"}
          </h6>
        </Col>
        {qualificationTypeID === QUALIFICATION_TYPES.POSTGRADUATION && (
          <Col sm={1} className="text-right">
            <Icon
              onClick={() =>
                deleteCandidateQualificationDetails(currentGraduationDetails.id)
              }
            >
              delete
            </Icon>
          </Col>
        )}
      </Row>
      <Form.Group as={Row} controlId="degree">
        <Form.Label column sm={2}>
          Degree*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            required
            pattern={alphaNumericWithSpecialCharacterPattern}
            placeholder="Degree"
            type="text"
            name="degree"
            value={currentGraduationDetails.degree}
            onChange={handleOnChangeGraduationDetails}
            autoFocus
            onBlur={handOnBlurInput}
            isInvalid={errors.degree}
          />
          {errors.degree && (
            <Form.Control.Feedback type="invalid">
              {errors.degree.type === "required" && "Degree is required"}
              {errors.degree.type === "pattern" &&
                "Invalid characters entered for Degree"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={2} className="text-right">
          Specialization*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            required
            placeholder="Specialization"
            type="text"
            name="specialization"
            value={currentGraduationDetails.specialization}
            onChange={handleOnChangeGraduationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.specialization}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.specialization && (
            <Form.Control.Feedback type="invalid">
              {errors.specialization.type === "required" &&
                "Specialization is required"}
              {errors.specialization.type === "pattern" &&
                "Invalid characters entered for Specialization"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="yearGrade">
        <Form.Label column sm={2}>
          Completed Year*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            required
            placeholder="Year of Completion"
            type="text"
            name="completionYear"
            value={currentGraduationDetails.completionYear}
            onChange={handleOnChangeGraduationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.completionYear}
            pattern={yearPattern}
          />
          {errors.completionYear && (
            <Form.Control.Feedback type="invalid">
              {errors.completionYear.type === "required" &&
                "Completed Year is required"}
              {errors.completionYear.type === "pattern" &&
                "Please enter valid Year"}
            </Form.Control.Feedback>
          )}
        </Col>
        <Form.Label column sm={2} className="text-right">
          Percentage/Grade*
        </Form.Label>
        <Col sm={4}>
          <Form.Control
            size="sm"
            required
            placeholder="Grade"
            type="text"
            name="grade"
            value={currentGraduationDetails.grade}
            onChange={handleOnChangeGraduationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.grade}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.grade && (
            <Form.Control.Feedback type="invalid">
              {errors.grade.type === "required" &&
                "Percentage/Grade is required"}
              {errors.grade.type === "pattern" &&
                "Please enter valid Percentage/Grade"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="college">
        <Form.Label column sm={2}>
          College*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="College"
            type="text"
            name="college"
            value={currentGraduationDetails.college}
            onChange={handleOnChangeGraduationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.college}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.college && (
            <Form.Control.Feedback type="invalid">
              {errors.college.type === "required" && "College is required"}
              {errors.college.type === "pattern" &&
                "Invalid characters entered for College"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId="university">
        <Form.Label column sm={2}>
          University*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="University"
            type="text"
            name="university"
            value={currentGraduationDetails.university}
            onChange={handleOnChangeGraduationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.university}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.university && (
            <Form.Control.Feedback type="invalid">
              {errors.university.type === "required" &&
                "University is required"}
              {errors.university.type === "pattern" &&
                "Invalid characters entered for University"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId="location">
        <Form.Label column sm={2}>
          Location*
        </Form.Label>
        <Col sm={10}>
          <Form.Control
            size="sm"
            required
            placeholder="Location"
            type="text"
            name="location"
            value={currentGraduationDetails.location}
            onChange={handleOnChangeGraduationDetails}
            onBlur={handOnBlurInput}
            isInvalid={errors.location}
            pattern={alphaNumericWithSpecialCharacterPattern}
          />
          {errors.location && (
            <Form.Control.Feedback type="invalid">
              {errors.location.type === "required" && "Location is required"}
              {errors.location.type === "pattern" &&
                "Invalid characters entered for Location"}
            </Form.Control.Feedback>
          )}
        </Col>
      </Form.Group>
    </Fragment>
  );
};
export default GraduationForm;
